import React from "react";

const FormSubmissionMessage = ({ fail, success, submitMessage }) => {
  return (
    <div
      style={{
        backgroundColor: fail ? "#e74c3c" : success ? "#27ae60" : "#27ae60",
        padding: "40px 30px",
        margin: "30px 0px",
        color: "#fff",
        textAlign: "center",
        maxHeight: "fit-content",
      }}
    >
      {submitMessage.text}{" "}
      {submitMessage.phoneLink && (
        <a
          style={{ color: "#fff", fontWeight: "bold" }}
          href={`tel:${submitMessage.phoneLink}`}
        >
          call us at{" "}
          <span style={{ whiteSpace: "nowrap" }}>
            {submitMessage.phoneLink}
          </span>
        </a>
      )}
    </div>
  );
};

export default FormSubmissionMessage;
